/**
 * Global namespace for most components `toggle` option.
 */
const dataBsToggle = 'data-bs-toggle';
export default dataBsToggle;
